<template>
	<div class="news-wrap">
		<el-form label-width="100px" :model="form" ref="form" :rules="rules">
			<el-form-item label="标题" prop="news_title">
				<el-input v-model="form.news_title" placeholder="请输入新闻标题" />
			</el-form-item>
			<el-form-item label="所在栏目" prop="news_catid" v-if="form.news_catid!=15">
				<el-select placeholder="请选择所在栏目" v-model="form.news_catid">
					<el-option v-for="item in catList" :key="item.id" :label="item.ncat_title" :value="item.id" />
				</el-select>
			</el-form-item>
			<el-form-item label="所属类别"
				v-if="form.news_catid==16||form.news_catid==19||form.news_catid==20||form.news_catid==21">
				<el-select placeholder="请选择所属类别" v-model="form.catid">
					<el-option v-for="item in newsCatList" :key="item.id" :label="item.catname" :value="item.id" />
				</el-select>
			</el-form-item>
			<el-form-item label="SEO关键词">
				<el-input placeholder="请输入SEO关键词,用 ' , ' 间隔" v-model="form.keywords" />
			</el-form-item>
			<el-form-item label="SEO描述">
				<el-input placeholder="请输入SEO描述" v-model="form.description" />
			</el-form-item>
			
			<template v-if="form.news_catid==19||form.news_catid==20||form.news_catid==21">
				<el-form-item 
				  label="展会时间" 
				  prop="exhibitionDate" 
				  :required="true"
				>
				  <el-date-picker 
					v-model="dateData" 
					type="datetimerange" 
					range-separator="至" 
					start-placeholder="开始日期"
					end-placeholder="结束日期" 
					value-format="yyyy-MM-dd hh:mm:ss" 
					@change="handleDate" 
					 clearable
				  />
				</el-form-item>
				
				<el-form-item 
				  label="展会开办地址" 
				  prop="address"
				  :required="true"
				>
				  <el-input placeholder="请输入展会开办地址" v-model="form.address" />
				</el-form-item>
			  </template>
			
			<el-form-item label="相关产品链接" v-if="form.news_catid!=17&&form.news_catid!=15">
				<el-input placeholder="请输入相关产品链接" v-model="form.goods_url" />
			</el-form-item>
			<el-form-item :label="form.news_catid!=17?'文章来源':'发放单位'" v-if="form.news_catid!=15">
				<el-input :placeholder="form.news_catid!=17?'请输入文章来源':'请输入发放单位'" v-model="form.news_source" />
			</el-form-item>
			<el-form-item label="封面图" v-if="form.news_catid!=15" prop="news_photo">
				<el-upload class="avatar-uploader" :action="picUrl" :show-file-list="false"
					element-loading-text="拼命加载中……" :on-progress="change" :before-upload="beforeAvatarUpload"
					v-loading.fullscreen.lock="loading" :data="fileInfo" :on-success="handleAvatarSuccess"
					accept="image/jpeg,image/png">
					<img v-if="imageUrl" :src="imageUrl" :onerror="imgSrc" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div class="tishinews">
					小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					<br />图片建议比例:3:2
				</div>
			</el-form-item>
			<el-form-item label="技术文档" v-if="form.news_catid==16">
				<el-upload action="/uploadFile" :data="{user_id}" :on-remove="handleBookRemove"
					:before-remove="beforeBookRemove" :limit="1" :on-exceed="handleBookExceed"
					:on-success="handleBookSuceess" accept=".doc,.pdf,.docx,.wls,.wlsx">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传doc/pdf/docx文件</div>
				</el-upload>
			</el-form-item>
			<el-form-item label="详细内容" prop="news_content">
				<tinyMce :content="form.news_content" :change.sync="form.news_content" />
			</el-form-item>
			<div class="submit-wrap">
				<el-button type="primary" @click="handleSubmit">提交</el-button>
			</div>
		</el-form>
	</div>
</template>


 <script>
	import tinyMce from '@/components/plug/tinyMce'
	export default {
		data() {
			// 在 data 内部定义验证函数
			const validateExhibitionDate = (rule, value, callback) => {
				console.log("????????????",rule, value, callback)
				console.log(">?",this.form.news_catid)
				console.log("=== 验证执行 ===");
				  console.log("rule:", rule);
				  console.log("value:", value); // 这个 value 参数是 exhibitionDate 字段的值，但你用的是 dateData
				  console.log("this.dateData:", this.dateData);
				  console.log("this.dateData 类型:", typeof this.dateData);
				  console.log("this.dateData 长度:", this.dateData ? this.dateData.length : 'null');
				  console.log("this.form.start_time:", this.form.start_time);
				  console.log("this.form.end_time:", this.form.end_time);
				  console.log("当前栏目:", this.form.news_catid);
				
				
				if (this.form.news_catid == 19 || this.form.news_catid == 20 || this.form.news_catid == 21) {
					console.log("？？？",this.dateData,!this.dateData,this.dateData.length)
					if (!value || value.length != 2) {
						callback(new Error('请选择展会时间'));
					} else {
						console.log("21222")
						callback();
					}
				} else {
					console.log("?????")
					callback();
				}
			};
			
			const validateExhibitionAddress = (rule, value, callback) => {
				if (this.form.news_catid == 19 || this.form.news_catid == 20 || this.form.news_catid == 21) {
					if (!value || value.trim() === '') {
						callback(new Error('请输入展会开办地址'));
					} else {
						callback();
					}
				} else {
					callback();
				}
			};
			
			return {
				loading: false,
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				fileInfo: {
					type: "news",
				},
				user_id: this.$store.state.USER_ID,
				imageUrl: '',
				catList: [],
				newsCatList: [],
				form: {
					exhibitionDate:[],
					id: '',
					news_title: '',
					news_catid: '',
					catid: '',
					keywords: '',
					description: '',
					start_time: '',
					end_time: '',
					address: '',
					goods_url: '',
					news_source: '',
					book: '',
					news_photo: '',
					news_content: ''
				},
				dateData: [],
				rules: {
					news_title: [{
						required: true,
						message: '请输入标题'
					}],
					news_catid: [{
						required: true,
						message: '请选择所在栏目'
					}],
					news_photo: [{
						required: true,
						message: '请上传图片'
					}],
					news_content: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.news_content === '') {
								callback(new Error('请输入详细内容'));
							} else {
								callback();
							}
						}
					}],
					exhibitionDate: [{
						validator: validateExhibitionDate, 
						trigger: 'change'
					}],
					address: [{
						validator: validateExhibitionAddress, 
						trigger: 'blur'
					}]
				},
				picUrl: '',
				// 上传视频
				videoFlag: false,
				//是否显示进度条
				videoUploadPercent: "",
				//进度条的进度，
				isShowUploadVideo: false,
				//显示上传按钮
				videoForm: {
					showVideoPath: ''
				}
			}
		},
		created() {
			this.getCat()
			this.getHangye()
			this.picUrl = this.$store.state.BASE_URL + '/uploadImgOne.html'
		},
		methods: {
			change(event, file, fileList) {
				this.loading = true;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleAvatarSuccess(res, file) {
				if (res.src != null) {
					this.loading = false;
					this.form.news_photo = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				} else {
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			getCat() {
				return new Promise(resolve => {
					this.$axios.post('Myseller-setting-getnewscat', {
						user_id: this.$store.state.USER_ID
					}).then(data => {
						this.catList = data
						resolve()
					})
				})
			},
			getHangye() {
				return new Promise(resolve => {
					this.$axios.post('Myseller-setting-gethangye').then(data => {
						this.newsCatList = data
						resolve()
					})
				})
			},
			handleSubmit() {
				this.$refs['form'].validate(valid => {
					if (valid) {
						if (this.form.news_content.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.news_content = this.form.news_content.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						console.log("this.form",this.form)
						this.$emit('eventForm', this.form)
					} else {
						this.$message.error('请补全必填项')
						return false
					}
				});
			},
			handleBookRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handleBookExceed(files, fileList) {
				this.$message.warning('技术文档只限上传一份，可先删除现有文档后在提交');
			},
			beforeBookRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handleBookSuceess(res, file, fileList) {
				if (res.code == 200) {
					this.form.book = res.data
				} else {
					this.$message.error(res.data);
				}
			},
			handleDate(val) {
				console.log("val",val,val.length == 2)
				if (val && val.length == 2) {
					this.form.start_time = val[0];
					this.form.end_time = val[1];
					this.dateData = val;
					this.form.exhibitionDate = val; // 同步到验证字段
					
				} else {
					this.form.start_time = '';
					this.form.end_time = '';
					this.dateData = [];
					this.form.exhibitionDate = [];
				}
				// 触发验证
				this.$nextTick(() => {
					console.log("?")
					if (this.$refs.form && (this.form.news_catid == 19 || this.form.news_catid == 20 || this.form.news_catid == 21)) {
						this.$refs.form.validateField('exhibitionDate');
					}
				});
			},
			// 上传视频
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 10;
				if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
					this.$message.error("请上传正确的视频格式");
					return false;
				}
				if (!fileSize) {
					this.$message.error("视频大小不能超过10MB");
					return false;
				}
				this.isShowUploadVideo = false;
			},
			uploadVideoProcess(event, file, fileList) {
				this.videoFlag = true;
				this.videoUploadPercent = file.percentage.toFixed(0) * 1;
			},
			handleVideoSuccess(res, file) {
				this.isShowUploadVideo = true;
				this.videoFlag = false;
				this.videoUploadPercent = 0;
				if (res.Code == 0) {
					this.videoForm.showVideoPath = res.Data;
				} else {
					this.$message.error(res.Message);
				}
			}
		},
		components: {
			tinyMce
		},
		props: {
			newsForm: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		watch: {
			newsForm(val) {
				console.log("val",val)
				this.form = val
				this.form.news_catid  = val.news_catid
				this.form.id = val.id
				this.form.news_photo = val.photo
				this.imageUrl = val.photo ? this.$store.state.IMG_URL + val.photo : ''
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.form.start_time = val.start_time ? val.start_time :'';
				this.form.end_time = val.end_time ? val.end_time :'';
				this.dateData = [val.start_time,val.end_time];
				this.form.exhibitionDate = [val.start_time,val.end_time];
			},
			'form.news_catid'(newVal) {
				this.$nextTick(() => {
					console.log("?",this.$refs.form)
					console.log("newVal",newVal)
					if (this.$refs.form) {
						if (newVal == 19 || newVal == 20 || newVal == 21) {
							// 清空验证并重新验证
							this.$refs.form.clearValidate(['exhibitionDate', 'address']);
							this.$refs.form.validateField('exhibitionDate');
							this.$refs.form.validateField('address');
						  } else {
							this.$refs.form.clearValidate(['exhibitionDate', 'address']);
						  }
					}
				});
			},
			// 监听日期数据变化，自动触发验证
			dateData: {
				handler() {
					console.log("?",this.$refs.form )
					if (this.$refs.form && (this.form.news_catid == 19 || this.form.news_catid == 20 || this.form.news_catid == 21)) {
						console.log("走了吗")
						this.$refs.form.validateField('exhibitionDate');
					}
				},
				deep: true
			}
		}
	}
 </script>
<style scoped>
	.el-form {
		padding: 20px;
		max-width: 1020px;
	}

	.news-wrap>>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.news-wrap>>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.news-wrap>>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.news-wrap>>>.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.submit-wrap {
		text-align: center;
	}

	.tishinews {
		color: #666ee8;
	}
</style>